import React from 'react';
import GridViewToggle, { MobileGridViewMode } from './GridViewToggle';

interface GridHeroActionsProps {
  mode: MobileGridViewMode;
  onToggle: () => void;
  toolbar?: React.ReactNode;
  children?: React.ReactNode;
}

const GridHeroActions = ({ mode, onToggle, toolbar, children }: GridHeroActionsProps) => (
  <div className="grid-usuario__hero-actions">
    {toolbar ? (
      <div className="grid-usuario__hero-toolbar">
        <GridViewToggle mode={mode} onToggle={onToggle} />
        {toolbar}
      </div>
    ) : (
      <GridViewToggle mode={mode} onToggle={onToggle} />
    )}
    {children}
  </div>
);

export default GridHeroActions;
